module.exports = __webpack_public_path__ + "static/media/threat-outlook.f4bbf8c9.svg";